import React from 'react';
import './RowDocumentCode.scss';
import DynaDatePicker from "../../../DynaView/DynaDatePicker";
import DynaInput from "../../../DynaView/DynaInput";
import DynaTimePicker from "../../../DynaView/DynaTimePicker";

const RowDocumentCode = ({setSendData, sendData}) => {

  return (
    <div className='rowDocumentCode'>

      <DynaInput label={"شماره سند"}
                 name={"documentCode"}
                 className={"solid-dyna-input"}
                 placeholder={"شماره سند را وارد کنید"}
                 value={sendData?.documentCode}
                 disabled={true}
                 type={"number"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />

      <DynaDatePicker label={"تاریخ"}
                      name={"documentDate"}
                      className={"solid-dyna-input"}
                      value={sendData?.documentDate}
                      setDataFromComponent={(data) => {
                        setSendData({...sendData, ...data})
                      }}
      />

      <DynaTimePicker
        name={"documentTime"}
        label="زمان"
        className={"solid-dyna-input"}
        value={sendData?.documentTime}
        setDataFromComponent={(data) => {
          setSendData({...sendData, ...data})
        }}
      />

    </div>
  );
};

export default RowDocumentCode;